import { render, staticRenderFns } from "./ImportImei.vue?vue&type=template&id=2ca60f1a"
import script from "./ImportImei.vue?vue&type=script&lang=js"
export * from "./ImportImei.vue?vue&type=script&lang=js"
import style0 from "./ImportImei.vue?vue&type=style&index=0&id=2ca60f1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports